import { getFunctions, httpsCallable } from 'firebase/functions';

export type ServiceRequestFile = { name: string; path: string; contentType: string; size: number };

const callable = httpsCallable(getFunctions(undefined, 'us-central1'), 'manageServiceRequests');

export async function uploadServiceRequestFile(uploadType: 'attachment' | 'delivery' | 'surveyMap' | 'surveyPhoto', organizationId: string, requestId: string, file: File): Promise<ServiceRequestFile> {
    const result = await callable({
        action: 'createFileUpload', uploadType, organizationId, requestId,
        fileName: file.name, contentType: file.type, size: file.size,
    });
    const data = result.data as { uploadUrl: string; path: string };
    const response = await fetch(data.uploadUrl, { method: 'PUT', headers: { 'Content-Type': file.type }, body: file });
    if (!response.ok)
        throw new Error(`File upload failed (${response.status}).`);
    return { name: file.name, path: data.path, contentType: file.type, size: file.size };
}

export async function serviceRequestDownloadUrl(organizationId: string, requestId: string, file: ServiceRequestFile): Promise<string> {
    const result = await callable({ action: 'createFileDownload', organizationId, requestId, path: file.path });
    return String((result.data as any).downloadUrl || '');
}
